import { accountServicesQueryOptions, personalInfoQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useSetDefaultAccount() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: (id: string) =>
      api.post('/api/v1/account-association/default-account', { ServiceAccount: id }),
    successLogAction: () => ({ ActionType: ActionType.ChangeAccount }),
    errorLogAction: () => ({ ActionType: ActionType.ChangeAccount }),
    onSuccess: (_, id, _mutateResult, { client }) => {
      client.setQueryData(accountServicesQueryOptions.queryKey, (old) => {
        if (!old) return old;
        old.Holder.ServiceAccounts = old.Holder.ServiceAccounts.map((service) => ({
          ...service,
          IsDefault: service.Id === id,
        }));
        return old;
      });
      client.setQueryData(personalInfoQueryOptions.queryKey, (old) => {
        if (!old) return old;
        return { ...old, DefaultAccountId: id };
      });
      toast.show('success', t('Common.SnackBar.DefaultHouseHoldUpdated'));
    },
  });
}
